// MainLayout.tsx
import React, { useState, useCallback, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Top from "../../container/main/Top";
import SidebarMenu from "../../component/SidebarMenu";
import Footer from "./Footer";
import { compactNavigationQuery } from "../../global/navigation";

const MainLayout: React.FC = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	const location = useLocation();
    const closeMenu = useCallback(() => setMenuOpen(false), []);
    useEffect(() => { closeMenu(); }, [location, closeMenu]);
    useEffect(() => {
        const media = window.matchMedia(compactNavigationQuery);
        const resize = () => { if (!media.matches) closeMenu(); };
        media.addEventListener("change", resize);
        return () => media.removeEventListener("change", resize);
    }, [closeMenu]);

	const hideFooter = ["/login", "/writeNew"].includes(location.pathname);

	return (
		<div className="App">
			<Top menuOpen={menuOpen} onMenuClick={() => setMenuOpen(true)} />
			<SidebarMenu isOpen={menuOpen} onClose={closeMenu} />

			{/* 🔥 Topbar 프레임 */}
			<div className="PageFrame">
				<div className="ContentsBody">
					<Outlet />
				</div>

				{/* Footer도 프레임 안에 */}
				{!hideFooter && <Footer />}
			</div>
		</div>
	);
};

export default MainLayout;
